import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";

import SubscriptionForm from "./newsletterSubscription.component";

const NewsletterSubscription = () => {
    const dispatch = useThunkDispatch();
    const isLoadingSubscribeToNewsLetter = useSelector(
        CustomerSelectors.isLoading
    );

    const onSubmit = async (info: any) => {
        return dispatch(CustomerModule.subscribeToNewsLetter(info));
    };

    return (
        <SubscriptionForm
            onSubmit={onSubmit}
            isLoading={isLoadingSubscribeToNewsLetter}
        />
    );
};

export { NewsletterSubscription };
